import React, { useState, useEffect } from "react";
import DashboardRouter from "./DashboardRouter";

const Dashboard = ({ user }) => {
  const [userRole, setUserRole] = useState("free");
  const [isLoadingUserRole, setIsLoadingUserRole] = useState(true);

  useEffect(() => {
    if (user) {
      loadUserRole();
    }
  }, [user]);

  const loadUserRole = async () => {
    try {
      setIsLoadingUserRole(true);

      // Check if user has admin privileges
      const adminEmails = [
        "admin@petid.com",
        "yngvithor@gmail.com", // Admin email
      ];

      // Check for pro users (could be from Firestore subscription collection)
      const proEmails = [
        "pro@petid.com",
        // Add pro user emails or fetch from database
      ];

      if (adminEmails.includes(user.email)) {
        setUserRole("admin");
      } else if (proEmails.includes(user.email)) {
        setUserRole("pro");
      } else {
        setUserRole("free");
      }

      console.log(`User role loaded: ${userRole} for ${user.email}`);
    } catch (error) {
      console.error("Error loading user role:", error);
      setUserRole("free"); // Default to free tier on error
    } finally {
      setIsLoadingUserRole(false);
    }
  };

  return (
    <DashboardRouter
      user={user}
      userRole={userRole}
      isLoadingUserRole={isLoadingUserRole}
    />
  );
};

export default Dashboard;
